import React from 'react';
import {withTranslation} from 'react-i18next';
import {connect} from 'react-redux';
import {Trans} from 'react-i18next';
import Popup from '../../index';
import Button from '../../../button/index';
import Version from '../../../version/index';
import Icon from '../../../icon/index';
import {loadZohoSalesIQ} from '../../../../utils/index';
import {showSupportDetailsPopup} from '../../../../../actions/popupActions';
import {withRouter} from 'react-router-dom';
import './index.css';

class SupportDetailsPopup extends React.Component {

	constructor(props) {
		super(props);

		this.openChat = this.openChat.bind(this);
	}

	/*componentDidMount() {
		if (this.props.profile !== null && window.location.pathname === '/support') {
			this.props.setShowHowDoesItWorksPopup(true)
		}
	}*/

	closePopup = () => {
		if (window.location.pathname === '/support') {
			this.props.setShowHowDoesItWorksPopup(false);
			this.props.history.push('/contacts')

		} else {
			this.props.setShowHowDoesItWorksPopup(false);
		}
	};

	openChat() {

		if (this.props.profile.domain.status === 'FREEMIUM' || this.props.profile.domain.status === 'EVAL') {
			if (window.$zoho) {
				window.$zoho.salesiq.floatwindow.visible('show');
			}
		} else {
			loadZohoSalesIQ();
			if (window.$zoho) {
				window.$zoho.salesiq.ready = () => {
					window.$zoho.salesiq.visitor.name(this.props.profile.name);
					window.$zoho.salesiq.visitor.email(this.props.profile.email);
					window.$zoho.salesiq.floatwindow.visible('show');
				}
			}
		}
	}

	render() {
		if (this.props.showSupportDetailsPopup) {
			if (this.props.profile) {
				if (this.props.profile.domain.plan === 'BUSINESS' || this.props.profile.domain.plan === 'ENTERPRISE') {
					return (
						<Popup className="p-4"
						       onClose={this.closePopup}>
							<h2 className="pr-5"><Icon className="text-danger"
							                           name="life-ring"/> {this.props.t('textHelpSupport')}</h2>
							{/* <p>Contact our support team and get the assistance you need. You can send us an email at <a
                                href="mailto:support@gmailsharedcontacts.com">support@gmailsharedcontacts.com</a>, chat with us through our website, or <Button className="btn-link m-0 p-0 d-inline align-baseline open-live-chat-btn" onClick={this.openChat}>click here</Button> if you want to live chat with us.</p> */}
							<Trans i18nKey="textSupportDetailsPopup1" components={{
								a: <a href='mailto:support@getsharedcontacts.com'> </a>,
								btn: <Button className="btn-link m-0 p-0 d-inline align-baseline open-live-chat-btn"
								             onClick={this.openChat}/>
							}}/>
							<Button className="btn-primary float-right"
							        onClick={this.closePopup}>{this.props.t('okText')}</Button>
							<p className="product-version">
								<small>{this.props.t('textGscTitle')}&reg; — <Version/></small>
							</p>
						</Popup>
					)
				} else {
					return (
						<Popup className="p-4"
						       onClose={() => this.props.setShowHowDoesItWorksPopup(false)}>
							<h2 className="pr-5"><Icon className="text-danger"
							                           name="life-ring"/> {this.props.t('textHelpSupport')}</h2>
							<p><Trans i18nKey="textSupportDetailsPopup2"
							          components={{a: <a href='mailto:support@getsharedcontacts.com'> </a>}}/></p>
							<Button className="btn-primary float-right"
							        onClick={this.closePopup}>{this.props.t('okText')}</Button>
							<p className="product-version">
								<small>{this.props.t('textGscTitle')}&reg; — <Version/></small>
							</p>
						</Popup>
					)
				}
			}
		} else {
			return null;
		}

	}
}

const mapStateToProps = (state) => {
	return {
		profile: state.profileReducer.getProfile,
		showSupportDetailsPopup: state.popupReducer.showSupportDetailsPopup,
	};
};

const mapDispatchToProps = (dispatch) => {
	return {
		setShowHowDoesItWorksPopup: (boolean) => {
			dispatch(showSupportDetailsPopup(boolean))
		}
	}
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(withTranslation()(SupportDetailsPopup)));
